import fetchFromApiServer from 'services/api';

export function fetchFundManagers(requestObject) {
  const url = `/fundmanager-page/fund-managers`;
  return fetchFromApiServer('GET', url, requestObject);
}
